export const IS_LOADING_AIKEYWORDS = "IS_LOADING_AIKEYWORDS";
export const AIKEYWORDS_DATA_SUCCESS = "AIKEYWORDS_DATA_SUCCESS";
export const AIKEYWORDS_DATA_FAILED = "AIKEYWORDS_DATA_FAILED";

export const IS_LOADING_SAVE_AIKEYWORDS = "IS_LOADING_SAVE_AIKEYWORDS";
export const SAVE_AIKEYWORDS_DATA_SUCCESS = "SAVE_AIKEYWORDS_DATA_SUCCESS";
export const SAVE_AIKEYWORDS_DATA_FAILED = "SAVE_AIKEYWORDS_DATA_FAILED";



